<div class="drawing-stream-popover" [class.visible]="visible">
  <div class="popover-header">
    <span>Drawing Stream</span>
    <button mat-icon-button class="close-button" (click)="close()" title="Close Debug Mode">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <ul>
    <li *ngFor="let message of messages">
      {{ message | json }}
    </li>
  </ul>
</div>
